import styled from 'styled-components';

interface ICardProps {
  type: 'submit' | 'to-submit';
}

export const Container = styled.div<ICardProps>`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* border: 1px solid #fff; */
  box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  border-radius: 1.2rem;
  height: 15.44rem;
  opacity: ${props => (props.type === 'to-submit' ? 0.8 : 1)};

  /* &:hover {
    box-shadow: 6px 12px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-3px);
  } */
`;

export const ImageChallenge = styled.img`
  width: 12.44rem;
  border-radius: 1.2rem 0 0 1.2rem;
  object-fit: cover;
  object-position: center;
`;

export const ChallengeDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.1rem;
  gap: 0.4rem;

  > h1 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.2rem;
    color: #1e88e5;
  }

  span {
    font-size: 0.8rem;
    display: -webkit-box;
    -webkit-line-clamp: 7; /* Número de linhas */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SeasonDetails = styled.div`
  > p {
    font-family: 'RedHatDisplay-Medium';
    font-size: 0.8rem;
    color: #000;
  }
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 0.6rem;

  > .primary-button {
    height: 1.8rem;
    padding: 0.8rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: 0.8rem;
    border-radius: 0.6rem;
    box-shadow: 0px 3px 15px rgba(255, 152, 0, 0.3);

    > svg {
      margin-right: 0.3rem;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .spinner-icon {
    animation: spin 1.5s linear infinite;
  }
`;

export const CountUsers = styled.div`
  display: flex;
  align-items: center;

  > svg {
    margin-right: 0.4rem;
  }

  font-family: 'RedHatDisplay-Medium';
  font-size: 0.8rem;
  color: #000;
`;
